const normalizedAddress = (address) => typeof address === 'string' ? address.trim() : '';

export const buildDriverCreatePayload = (formData) => {
    const payload = {
        account_type: formData.account_type,
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        password: formData.password,
        phone_num: formData.phone_num,
        address: normalizedAddress(formData.address),
    };

    if (formData.account_type === 'company') {
        payload.business_name = formData.business_name;
        payload.designation = formData.designation;
    }

    return payload;
};

export const getDriverProfileFormData = (driver) => ({
    first_name: driver.first_name || '',
    last_name: driver.last_name || '',
    email: driver.email || '',
    username: driver.username || '',
    phone_num: driver.phone_num || '',
    address: driver.address || '',
    business_name: driver.company?.business_name || '',
    designation: driver.company?.designation || '',
});

export const buildDriverUpdatePayload = (formData) => ({
    ...formData,
    address: normalizedAddress(formData.address),
});

export const buildEmployeeCreatePayload = (formData) => {
    const payload = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        username: formData.username,
        password: formData.password,
    };

    if (formData.email) payload.email = formData.email;
    if (formData.phone_num) payload.phone_num = formData.phone_num;
    if (normalizedAddress(formData.address)) payload.address = normalizedAddress(formData.address);
    if (formData.vehicle_id) payload.vehicle_id = formData.vehicle_id;

    return payload;
};
